import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { loadScript } from "vue-plugin-load-script";
import VueSmoothScroll from "vue3-smooth-scroll";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const app = createApp(App);
app.use(router);
app.use(VueSmoothScroll, { duration: 900 });
app.component("font-awesome-icon", FontAwesomeIcon).mount("#app");

loadScript("https://embed.laylo.com/laylo-sdk.js");
